import formatCurrency from '@/helpers/format/format-currency';
import store from '@/store';



function dollars(value, { trimZeros } = {}) {
  return formatCurrency(value, {
    currencyCode: store.getters?.['merchant/currencyCode'] || 'USD',
    locale: store.state?.locale?.deviceLocale || 'en-US',
    trimZeros
  });
}



export default dollars;
